<template>

  <div id="app">
    <el-config-provider :locale="locale">
        <router-view></router-view>
    </el-config-provider>
   
  </div>
</template>

<script>
import { defineComponent } from '@vue/runtime-core'
import  {ElConfigProvider} from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
export default defineComponent (
{
  components:{
    [ElConfigProvider.name]:ElConfigProvider
  },
  setup(){
    return{
      locale:zhCn
    }
  }
}
)
</script>
<style>
.none_ {
  display: none;
}

</style>
